export default "__VITE_ASSET__BJ8KvEpZ__"